import { render } from "./Auth.vue?vue&type=template&id=fd614d84&ts=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__